import * as React from "react";
import { SVGProps } from "react";
function SvgFileTypePdfIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 29H6v-9h2v7h16v-7h2v9ZM6 2h20v9h-2V4H8v7H6V2Z"
        fill="#D0021B"
      />
      <path
        d="M8.3 12.7h2.285c.834 0 1.455.189 1.863.567.408.378.612.888.612 1.53 0 .648-.204 1.161-.612 1.539-.408.378-1.029.567-1.863.567h-.999V19H8.3v-6.3Zm2.285 3.123c.426 0 .73-.084.91-.252.185-.174.278-.432.278-.774s-.093-.597-.279-.765c-.18-.174-.483-.261-.909-.261h-.999v2.052h1Zm3.471-3.123h2.277c.774 0 1.383.234 1.827.702.45.462.675 1.146.675 2.052v.72c0 .942-.225 1.65-.675 2.124-.444.468-1.053.702-1.827.702h-2.277v-6.3Zm2.277 5.229c.378 0 .675-.135.891-.405.216-.27.324-.72.324-1.35v-.72c0-.594-.108-1.023-.324-1.287-.216-.264-.513-.396-.89-.396h-.99v4.158h.99Zm3.665-5.229h4.13v1.071h-2.843v1.539h2.51v1.08h-2.51V19h-1.287v-6.3Z"
        fill="#D0021B"
      />
    </svg>
  );
}
export default SvgFileTypePdfIcon;
